module.exports = __webpack_public_path__ + "img/76.981286d2.png";